import { patchRequest, getRequest } from "@react/helpers/fetch"

export const patchTask = (projectId, taskId, attrs) =>
  patchRequest({
    url:  `/projects/${projectId}/project_tasks/${taskId}.json`,
    body: { project_task: attrs },
  })

export const fetchAssignableOptions = (projectId) =>
  getRequest(`/projects/${projectId}/project_tasks/assignable_options.json`)
